import { useMutation } from 'react-query';

type UseBatchMutationOptions<Item, Response> = {
  mutationFn: (item: Item) => Promise<Response>;
  onSuccess?: (results: Response[]) => void;
  onError?: (error: unknown) => void;
};

export function useBatchMutation<Item, Response>({
  mutationFn,
  onSuccess,
  onError,
}: UseBatchMutationOptions<Item, Response>) {
  const mutation = useMutation(async (items: Item[]) => {
    return Promise.all(items.map((item) => mutationFn(item)));
  });

  return {
    ...mutation,
    mutate: (items: Item[]) =>
      mutation.mutate(items, {
        onSuccess: (results) => onSuccess?.(results),
        onError: (error) => onError?.(error),
      }),
  };
}
